"use client";

import { features } from "./social-proof-features";

export function SocialProof({ isMobile = false }: { isMobile?: boolean }) {
  return (
    <div className="rounded-md w-full sm:w-fit space-y-6">
      <div className="flex flex-wrap gap-4">
        {features.map((feature) => (
          <div
            key={feature.label}
            className={`flex items-center gap-3 rounded-full px-5 py-3 text-sm font-bold ${isMobile ? "bg-white/90 text-black shadow-sm" : "bg-white/10 text-white"}`}
          >
            <img src={feature.icon} alt={feature.label} className="w-5 h-5" />
            {feature.label}
          </div>
        ))}
      </div>

      <div
        className={`border rounded-lg p-4 text-base font-semibold ${isMobile ? "border-gray-200 bg-white/90 text-black shadow-sm" : "border-blue-200/10 bg-white/10 text-white"}`}
      >
        We've paid over 50,000 users. Your data is encrypted and handled
        securely by our team.
      </div>
    </div>
  );
}

export default SocialProof;
